<template>
  <ed-input-item :label="label" :info="info" :name="name" :required="required">
    <el-date-picker
      :value="value"
      :name="name"
      :type="type"
      :placeholder="format"
      :value-format="format"
      :format="format"
      :picker-options="handleDateOptions"
      :clearable="clearable"
      :disabled="disabled"
      :rules="rules"
      @input="$emit('input', $event)"
      @keydown="$emit('keydown', $event)"
      @keyup="$emit('keyup', $event)"
      @change="$emit('change', $event)"
    />
  </ed-input-item>
</template>

<script>
import EdFormMixin from "./mixins/formControl";
import EdInputItem from "./EdInputItem";

export default {
  name: "EdInputDate",
  mixins: [EdFormMixin],
  components: { EdInputItem },
  props: {
    maxDaysTomorrow: {
      type: [String, Number],
      required: false,
      default: null,
    },
    tomorrowDisabled: {
      type: [Boolean],
      required: false,
      default: false,
    },
    yesterdayDisabled: {
      type: [Boolean],
      required: false,
      default: false,
    },
    type: {
      type: [String],
      required: false,
      default: "date",
    },
    format:{
      type: [String],
      required: false,
      default: "dd/MM/yyyy",
    }
  },
  data() {
    return {};
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {
    handleDateOptions() {
      var options = {};

      if (this.yesterdayDisabled || this.tomorrowDisabled) {
        options.disabledDate = this.handlerDisable;
      }

      return options;
    },
  },
  methods: {
    handlerDisable(date) {
      var hoje = this.$utilidade.toDate(null, true, "YYYY-MM-DD");
      date = this.$utilidade.toDate(date, true, "YYYY-MM-DD");

      if (this.tomorrowDisabled && this.maxDaysTomorrow) {
        let amanha = this.$utilidade.toDate(
          this.$utilidade.addDate(this.maxDaysTomorrow, hoje, "d"),
          true,
          "YYYY-MM-DD"
        );

        if (date > amanha) {
          return true;
        }
      }

      return date < hoje;
    },
  },
};
</script>



// WEBPACK FOOTER //
// EdInputDate.vue?4e2af9ca